(() => {
  'use strict';

  document.body.classList.add('shabima-landing-v1-page', 'shabima-medicube-product-v1-page');

  const formatCurrencyLabels = () => {
    document.querySelectorAll('.price-item').forEach((element) => {
      if (element.querySelector('.mcv1-currency')) return;
      const value = element.textContent.trim();
      if (!/\sCOP$/.test(value)) return;
      const amount = value.replace(/\s*COP$/, '').trim();
      const currency = document.createElement('span');
      currency.className = 'mcv1-currency';
      currency.textContent = 'COP';
      element.textContent = '';
      element.append(document.createTextNode(`${amount} `), currency);
    });
  };

  const hideNativeCheckout = () => {
    document.querySelectorAll('.product-form__submit:not([id*="_rsi"]):not([class*="_rsi"])').forEach((button) => {
      button.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('.shopify-payment-button').forEach((container) => {
      if (!container.querySelector('[id*="_rsi"], [class*="_rsi"]')) {
        container.style.setProperty('display', 'none', 'important');
      }
    });
  };

  const initializedNewsletterFields = new WeakSet();
  const sanitizeReleasitCopy = () => {
    document.querySelectorAll('#_rsi-cod-form-modal ._rsi-custom-text-field').forEach((element) => {
      const text = element.textContent || '';
      if (text.includes('9 de cada 10 pedidos')) {
        element.textContent = 'Revisa que tu dirección incluya barrio, conjunto y número de apartamento cuando corresponda. Esto ayuda a evitar retrasos.';
      } else if (text.includes('Tu compra está 100% protegida')) {
        element.textContent = '¿Prefieres no esperar al transportador? Puedes pagar anticipadamente y autorizar la entrega en portería o a una persona de confianza. Revisa el total y el medio de pago antes de confirmar.';
      }
    });

    document.querySelectorAll('#_rsi-cod-form-modal ._rsi-buy-now-button-subtitle').forEach((element) => {
      if (element.textContent.trim() === 'Compra Segura y Verificada') element.textContent = 'Pago al recibir disponible';
    });

    document.querySelectorAll('#_rsi-cod-form-modal input[name="newsletter_subscribe_checkbox"]').forEach((checkbox) => {
      if (initializedNewsletterFields.has(checkbox)) return;
      initializedNewsletterFields.add(checkbox);
      if (checkbox.checked) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const refreshProductUi = () => {
    hideNativeCheckout();
    formatCurrencyLabels();
    sanitizeReleasitCopy();
  };

  refreshProductUi();
  new MutationObserver(refreshProductUi).observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('[data-mcv1-back-to-buy]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector('.product__info-wrapper, .product__info-container');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-mcv1-open-releasit]').forEach((button) => {
    button.addEventListener('click', () => {
      const releasit = [...document.querySelectorAll('#_rsi-buy-now-button._rsi-buy-now-button-product, #_rsi-buy-now-button-overwrite._rsi-buy-now-button-product')]
        .find((element) => !element.classList.contains('_rsi-buy-now-button-product-floating') && element.getBoundingClientRect().width > 0);
      if (releasit) {
        releasit.click();
        return;
      }
      const target = document.querySelector('.product__info-wrapper, .product__info-container');
      if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });
})();
